/* eslint-disable no-unused-vars */

import { useLocation, useNavigate, useParams } from "react-router";
import { DocumentIcon, InvestigatorIcon } from "../../assets/common-svg/CommonSvg";
import CustomDetailComponent from "../../components/doctor-detail-component/DocotorDetail";
import { CustomWrapperCard } from "../../components/custom-product-cards/custom-wrapper-card/CustomWrapperCard";
import CustomTable from "../../components/custom-table/CustomTable";
import TrialInfoComponent from "../../components/trial-info-component/TrialInfoComponent";
import { Typography, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import { phaseDetailsData } from "../../utils/tableData";
import PhaseApi from "../../services/phase";
import { setAssignedForm, setPhaseDetail } from "../../store/reducers/phase-reducer";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SubjectApi from "../../services/subjectService";
import { useDispatch, useSelector } from "react-redux";
import SubAdminApi from "../../services/subAdminService";
import { AddNewSubject, AddNewSubjectPhase, EditSubjectPhase } from "../../utils/formik/initialValues";
import { addNewSubjectPhaseValidationSchema, addNewSubjectValidationSchema, editSubjectPhaseValidationSchema, recordedDateSchema } from "../../utils/formik/validationSchema";
import CustomModel from "../../components/custom-model/CustomModel";
import DiseaseManagementApi from "../../services/diseaseService";
import { GenderList } from "../../utils/common";
import moment from "moment";
import { setSnackbar } from "../../store/reducers/snackBar";
import { CustomSnackbar } from "../../components/snackbar/CustomSnackbar";
import SelectFormModel from "../../components/custom-model/SelectFormModel";
import NoDataCard from "../../components/no-data-card";
import ProductApi from "../../services/productService";
import ConfirmationModal from "../../components/modal-contents/ConfirmationModal";

const convertSubjectData = (data, alignment, curr_page, page_details, order, isAddNewVisit, isAllApproved) => {
  return data?.map((sub, index) => {
    let SerialNo = order == 'asc' ? (page_details?.no_of_records - ((curr_page - 1) * 10)) - index : index + 1 + ((curr_page - 1) * 10);
    let transformId = sub?.id;
    let transformPatientId = sub?.patient_id || "--";
    let transformedSubjectInitial = sub?.first_name + " " + sub?.last_name || "";
    let transformedPatientStatus = sub?.life_status == 'lost' ? 'Lost To Follow Up' : sub?.life_status;
    let transformedLastVisitType = sub?.last_visit_type || "--"
    let transformedGender = sub?.gender;
    let transformedInvestigator = sub?.investigatorDetails?.name || "N/A";
        let transformedHospitalName = sub?.hospitalDetails?.name|| "--"

    let transformeappointmentCount = sub?.appointmentCount;
    let transformedEditor = sub?.created_By?.name  || "--"
    let roleName = sub?.created_By?.role_details?.title ||  "N/A"
    let transformCycleCount = sub?.cycle
    let transformedStatus =
      sub?.status_details?.status.charAt(0).toUpperCase() +
      sub?.status_details?.status.slice(1);
        let lastAppointmentDate = sub?.last_visit_type && sub?.last_appointment_date
        ? moment(sub?.last_appointment_date).format("DD/MM/YYYY")
        : sub?.last_visit_type && !sub?.last_appointment_date
        ? moment(sub?.created_at).format("DD/MM/YYYY")
        : "--";
    let phaseId = sub?.phase_id;
    let subjectId = sub?.id
    let isActiveAppointment = isAddNewVisit ?? true;
    let allApproved = isAllApproved

    return alignment === "Subject"
      ? [
          transformPatientId,
          transformedSubjectInitial,
          transformedPatientStatus,
          transformedLastVisitType,
          transformeappointmentCount,
           transformedInvestigator,
          transformedHospitalName,
          transformedEditor,
          roleName,
          transformCycleCount,
          transformedGender,
          lastAppointmentDate,
          transformId,
          phaseId,
          subjectId,
          isActiveAppointment,
          allApproved
        ]
      : [
          SerialNo,
          transformedSubjectInitial,
          transformeappointmentCount,
          transformedStatus,
          transformedLastVisitType,
          transformedGender,
          lastAppointmentDate,
          transformId,
        ];
  });
};

export const TrailsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { id } = useParams();
  const snackbar = useSelector((state) => state.snackBar);
  const { loginId, role_id, role_slug } = useSelector((state) => state.loginData);
  const [phaseDetailLoading, setPhaseDetailLoading] = useState(false);
  const [isAddSubjectLoading, SetIsAddSubjectLoading] = useState(false);
  const [showAddSubjectButton, setShowAddSubjectButton] = useState(false);
  const [isFormLoading, SetIsFormLoading] = useState(false);
  const [isOpenFormModel, SetIsFormModel] = useState(false);
  const [recordedDate, setRecordedDate] = useState(null);
  const [recordedDateModel, setRecordedDateModel] = useState(false);
  const [recordedDateLoading, setRecordedDateLoading] = useState(null);
  const [isInvestigator] = useState(role_id === 2);
  const [isEditor] = useState(role_id === 5);
  const [isProjectManager] = useState(role_slug === "project-manager");

  const [phaseListDetails, setPhaseListDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [formTemplateList, setFormTemplateList] = useState([]);
  const [alignment, setAlignment] = useState("Subject");
  const [subjectData, setSubjectData] = useState(
    phaseDetailsData(alignment, role_id, role_slug)
  );
  const [status, setStatus] = useState([2]);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [currentPage, setCurrentpage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [openAddSubjectModal, setOpenAddSubjectModal] = useState(false);
  const [pIList, setPIList] = useState([]);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('');
  const [subAdminId, setSubAdminID] = useState(null);
  const [subAdminList, setsubAdminList] = useState([]);
  const [statusDropdownList, setStatusDropdownList] = useState([]);
  const [statusId, setStatusId] = useState([]);
  const [subjectId, setSubjectId] = useState("");
  const [patientCycleConfirm, setPatientCycleConfirm] = useState(false);
  const [patientCycleErrMess, setPatientCycleErrMess] = useState("")
  const [patientFormValues, setPatientFormValues] = useState({})
  const [patientCycleLoading, setPatientCycleLoading] = useState(false)
  const [allSubjectList,setAllSubjectList]=useState([])
  const [editSubjectPatient, setEditSubjectPatient]=useState(EditSubjectPhase)
  const [gender, setGender] = useState('')
  const [rowId, setRowId] = useState(null);
  const [disableDisease, setDisableDisease]=useState(false)
  const [modelData, setModelData] = useState({
    title: "Add New Patient",
    editTitle: "Edit Editor",
    children: 
    isEditor ?
       [
          {
            type: "input",
            name: "first_name",
            label: "First Name",
            placeholder: "Enter First Name",
            IsRequired: true,
          },
          {
            type: "input",
            name: "last_name",
            label: "Last Name",
            placeholder: "Enter Last Name",
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "gender",
            label: "Gender",
            placeholder: "Select gender",
            data: [],
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "disease_id",
            label: "Disease",
            placeholder: "Select disease",
            data: [],
            IsRequired: true,
            disabled: false,
          },
          {
            type: "date",
            name: "dob",
            label: "Date of Birth",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
        ]
      : [
          {
            type: "input",
            name: "first_name",
            label: "First Name",
            placeholder: "Enter First Name",
            IsRequired: true,
          },
          {
            type: "input",
            name: "last_name",
            label: "Last Name",
            placeholder: "Enter Last Name",
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "gender",
            label: "Gender",
            placeholder: "Select gender",
            data: [],
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "investigator_id",
            label: "Principal Investigator",
            placeholder: "Select principal investigator",
            data: [],
            IsRequired: true,
          },
          {
            type: "dropdown",
            name: "editor_id",
            label: "Editor",
            placeholder: "Select Editor",
            data: [],
            IsRequired: true,
            dependency: "investigator_id" // Indicates this depends on PI selection

          },
          {
            type: "dropdown",
            name: "disease_id",
            label: "Disease",
            placeholder: "Select disease",
            data: [],
            IsRequired: true,
            disabled: false,
          },
          {
            type: "date",
            name: "dob",
            label: "Date of Birth",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
        ],
  });

  const [recordedDateModelData] = useState({
    title: "Add Date",
    children: [
      {
        type: "date",
        name: "last_recorded_visit_date",
        label: "Last Recorded Visit Date",
        placeholder: "Select Date",
        minDate: false,
        maxDate: new Date(),
        IsRequired: true,
      },
    ],
  });

  const handleNavigateToDetails = useCallback((row) => {
    const UpdatedNavigationArray = location.state;
    UpdatedNavigationArray?.push({
      name: "Patient Details",
      path: `${location.pathname}/patient-details/${row[row.length - 3]}`,
    });
    navigate(`patient-details/${row[row.length - 3]}`, {
      state: UpdatedNavigationArray,
    });
  }, []);

  // Function to get Editor for Patient Sub Admin by Value and Phase List ID
  const getEditorForSubjectSubAdmin = async (value) => {
    try {
      return await SubAdminApi.getEditorForSubjectSubAdmin(
        value,
        phaseListDetails?.id
      );
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  function arraysEqual(arr1, arr2) {
    // Check if the lengths of both arrays are the same
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Convert all elements to numbers, sort both arrays and compare
    let sortedArr1 = arr1?.map(Number)?.sort((a, b) => a - b);  // Convert to number and sort
    let sortedArr2 = arr2?.map(Number)?.sort((a, b) => a - b);  // Convert to number and sort

    for (let i = 0; i < sortedArr1?.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }

  const handleShowAddSubjectButton = (data) => {
    let showButton = false;

    if (data?.form_details) {
      // Check if all forms are approved
           showButton = data.form_details.every((value) => value?.is_approved !== false);
    }

    const tempArray = data.form_details.map((form) => {
      return String(form.type.id)
    });

    const IsTempateIdsEqual = arraysEqual(tempArray, data.template_type_ids);
    if (showButton && (role_id == 5 || role_slug === "project-manager")) {
      setSubjectData((prev) => ({
        ...prev,
        TableSearchActions: {
          ...prev.TableSearchActions,
                    actions: [{ key: "view", module: "subject", auth: 17 }, { key: "add", module: "subject", auth: 16 }, { key: "edit", module: "subject_pending", auth: 161 }],
        },
      }));
    } else {
      setSubjectData((prev) => ({
        ...prev,
        TableSearchActions: {
          ...prev.TableSearchActions,
                   actions: [{ key: "view", module: "subject", auth: 17 }, { key: "add", module: "appointmentManager", auth: 122 },{ key: "edit", module: "subject_pending", auth: 161 }],

        },
      }));
    }

    return (showButton && IsTempateIdsEqual);
  };

const getPhaseDetails = async () => {
  setPhaseDetailLoading(true);
  try {
    const res = await PhaseApi.getPhaseListDetails(id);
    setPhaseListDetails(res.data || []);
    
    const showButtonBoolean = handleShowAddSubjectButton(res?.data);
    setShowAddSubjectButton(showButtonBoolean);
    
    const principalInvestigators = res.data?.investigator_details?.principal_investigator || [];
    
    const piDropdownData = principalInvestigators.map(pi => ({
      id: pi.id,
      name: pi.name || `${pi.first_name} ${pi.last_name}`,
      value: pi.id
    }));
    
    setModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "investigator_id"
          ? {
              ...child, IsRequired: true,
              data: piDropdownData,
            }
 : child.name === "editor_id"
          ? { ...child, IsRequired: true } // Ensure editor remains required
          : child      ),
    }));
    
    // Load editors for the first PI only if there are PIs available and user is not editor
    if (piDropdownData.length > 0 && !isEditor) {
      const firstPiId = piDropdownData[0].id;
      await getEditorDropdown(firstPiId);
      
      // Set initial investigator_id for new subjects
      if (!rowId) {
        setEditSubjectPatient(prev => ({
          ...prev,
          investigator_id: firstPiId
        }));
      }
    } else if (isEditor) {
      // For editors, clear the PI and editor fields since they don't need them
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.filter(child => 
          child.name !== "investigator_id" && child.name !== "editor_id"
        ),
      }));
    } else {
      // If no PIs available, clear editor dropdown
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id"
            ? { 
                ...child, 
                placeholder: "No Principal Investigators available", 
                data: [] ,
                IsRequired: true // Keep required

              }
            : child
        ),
      }));
    }
    
    dispatch(setAssignedForm(res?.data?.form_details));
    dispatch(setPhaseDetail(res.data));
  } catch (error) {
    dispatch(setSnackbar({ value: true, message: error, color: "error" }));
  } finally {
    setPhaseDetailLoading(false);
    setLoading(false);
  }
};
  let isAllApproved = false;
  isAllApproved = phaseListDetails.form_details?.every(
    (item) => item.is_approved
  );

  useEffect(() => {
    setLoading(true);
    const updatedSubjectData = phaseDetailsData(alignment, role_id, role_slug);
    setSubjectData((prev) => ({
      ...prev,
      columnAlign: updatedSubjectData?.columnAlign,
      TableSearchActions: updatedSubjectData?.TableSearchActions,
      columns: updatedSubjectData?.columns,
    }));
    if (alignment === "Request") {
      setSubAdminID(null);
      setStatus([1, 3]);
    } else if (alignment === "Subject") {
      if (isInvestigator) {
        setStatus(null);
        return;
      }
      setStatusId(null);
      setStatus([2]);
    }
  }, [alignment]);

const handleOpenAddSubjectModal = async () => {
  setOpenAddSubjectModal(true);
  setRowId(null);
  setDisableDisease(false);
  
  // Reset form values
  setEditSubjectPatient(EditSubjectPhase);
  
  // Ensure we have PI data and set initial investigator_id
  const principalInvestigators = phaseListDetails?.investigator_details?.principal_investigator || [];
  if (principalInvestigators.length > 0) {
    const firstPiId = principalInvestigators[0].id;
    
    // Set initial value for investigator_id
    setEditSubjectPatient(prev => ({
      ...prev,
      investigator_id: firstPiId
    }));
    
    await getEditorDropdown(firstPiId);
  }
  setModelData(prevState => ({
    ...prevState,
    children: prevState.children.map(child => 
      child.name === "editor_id" 
        ? { ...child, IsRequired: true }
        : child
    )
  }));
};

  const GetMatchedKey = (key) => {
    switch (key.trim().toLowerCase()) {
      case 's.no': {
        return 'created_at'
      }
      case "patient id": {
        return "patient_id";
      }
      case "patient name": {
        return "name";
      }
      case "patient status": {
        return "life_status";
      }
      case "last recorded visit": {
        return "last_visit_type";
      }
      case "investigator": {
        return "investigator";
      }
      case "phase": {
        return "phase_name";
      }
      case "appointment completed": {
        return "appointmentCount";
      }
      case "editor": {
        return "editor";
      }
      case "cycle no.": {
        return "cycle";
      }
      case "gender": {
        return "gender";
      }
      case "stage": {
        return "stage";
      }
      case "apheresis status": {
        return "apheresis date";
      }
      default:
        return "";
    }
  };
async function getSubjectList() {
  const sortBy = GetMatchedKey(orderBy);

    // Get assignedPIs from loginData
  let investigatorParam = "";
  let editorParam = "";

  const assignedPI = phaseListDetails?.investigator_details?.assigned_investigator?.id;

if (role_slug === "investigator") {
  investigatorParam = `[${loginId}]`;
  editorParam = "";
}

else if (role_slug === "editor") {
  investigatorParam = assignedPI || "";
  editorParam = loginId;                       
}

else {
  investigatorParam = assignedPI || "";

  if (!isInvestigator) {
    editorParam = isEditor ? loginId : "";
  } else {
    editorParam = subAdminId;
  }
}

  try {
    const res = await SubjectApi.getSubjectList(
      phaseListDetails?.id,
      currentPage,
      10,
      tableFilters?.searchData,
      editorParam, // editor_id
      investigatorParam,
      "", // gender
      status,
      sortBy,
      order
    );

    setAllSubjectList(res.data);
    let rowData = convertSubjectData(
      res?.data || [],
      alignment,
      currentPage,
      res?.page_details,
      order,
      phaseListDetails?.isAddNewVisit,
      isAllApproved
    );
    setSubjectData((prev) => ({
      ...prev,
      rows: [...rowData],
    }));
    setTotalPage(
      Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
    );
    setCurrentpage(res?.page_details?.page);
    setLoading(false);
  } catch (error) {
    dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    setLoading(false);
    setSubjectData((prev) => ({
      ...prev,
      rows: [],
    }));
  }
}


  useEffect(() => {
    if (phaseListDetails?.id) {
      if (
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " "
      ) {
        setLoading(true);
        getSubjectList();
      }
    }
  }, [
    currentPage,
    tableFilters,
    phaseListDetails,
    subAdminId,
    statusId,
    status,
  ]);

  const handlePagination = async (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

const handleAddSubject = async (values, confirmation) => {
  SetIsAddSubjectLoading(true);
  setPatientFormValues(values);
  const formData = new FormData();

  formData.append("first_name", values.first_name?.trim());
  formData.append("last_name", values.last_name?.trim());
  
  if (values.upload_file) {
    if (values.upload_file instanceof FileList) {
      for (let i = 0; i < values.upload_file.length; i++) {
        formData.append("files", values.upload_file[i]);
      }
    } else {
      formData.append("files", values.upload_file);
    }
  }
  
  formData.append(
    "gender",
    GenderList.find((op) => op?.id == values.gender).name
  );  
  formData.append("dob", moment(values.dob).format("MM/DD/YYYY"));
  formData.append("disease_id", values.disease_id);
  formData.append("phase_id", phaseListDetails?.id);
  formData.append("phase_code", phaseListDetails?.phase_code);
  formData.append("phase_title", phaseListDetails?.title);
  formData.append("product_id", phaseListDetails?.product_id);
  formData.append("addCycle", confirmation || false);

  // SIMPLIFIED: Use ternary operators for investigator_id and editor_id
  formData.append(
    "investigator_id",
    isEditor ?
      // For editors: use the first available PI or assigned investigator
      (phaseListDetails?.investigator_details?.assigned_investigator?.id || 
             phaseListDetails?.investigator_details?.principal_investigator?.[0]?.id || "") :
      // For non-editors: use form value
      (values?.investigator_id || "")
  );
  
  formData.append(
    "editor_id", 
    isEditor ? 
      // For editors: use their own ID
      (loginId) : 
      // For non-editors: use form value
      (values?.editor_id || "")
  );

  // Validate investigator_id for non-editors
  if (!isEditor && (!values?.investigator_id || values.investigator_id === "undefined")) {
    dispatch(
      setSnackbar({
        value: true,
        message: "Please select a valid Principal Investigator",
        color: "error",
      })
    );
    SetIsAddSubjectLoading(false);
    return;
  }

  // Validate that investigator_id is set (for both editors and non-editors)
  const investigatorId = formData.get("investigator_id");
  if (!investigatorId || investigatorId === "undefined" || investigatorId === "") {
    dispatch(
      setSnackbar({
        value: true,
        message: "Principal Investigator is required",
        color: "error",
      })
    );
    SetIsAddSubjectLoading(false);
    return;
  }
  try {
    const response = await SubjectApi.addSubject(formData);
    
    dispatch(
      setSnackbar({
        value: true,
        message: response.message || "Patient added successfully",
        color: "success",
      })
    );    
    SetIsAddSubjectLoading(false);
    setLoading(true);
    getPhaseDetails();
    setOpenAddSubjectModal(false);
    setEditSubjectPatient(EditSubjectPhase);
  } catch (error) {
    SetIsAddSubjectLoading(false);
    
    // Better error handling for 422 errors
    if (error?.status === 422) {
      // Handle validation errors from backend
      const validationErrors = error?.errors || [];
      if (validationErrors.length > 0) {
        const firstError = validationErrors[0];
        const errorMessage = Object.values(firstError)[0] || "Validation failed";
        dispatch(
          setSnackbar({
            value: true,
            message: errorMessage,
            color: "error",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            value: true,
            message: "Validation failed. Please check all required fields.",
            color: "error",
          })
        );
      }
    } else {
      const addCycleError = error?.errors?.find((obj) =>
        Object.prototype.hasOwnProperty.call(obj, "addCycle")
      );
      if (addCycleError) {
        setPatientCycleErrMess(addCycleError?.addCycle);
        setPatientCycleConfirm(true);
      } else {
        // Safe error message handling
        dispatch(
          setSnackbar({
            value: true,
            message: error?.message || error || "Failed to Add Patient",
            color: "error",
          })
        );
      }
    }
  } finally {
    if (confirmation) {
      setPatientCycleConfirm(false);
    }
  }
};

  const hanldeFormSubmit = async (values) => {
    SetIsFormLoading(true); // Reset loading state
    setRecordedDateModel(true);
    setRecordedDate({ ...values, last_recorded_visit_date: "" });
    SetIsFormLoading(false);
    SetIsFormModel(false);
  };

  // Function to get SubAdmin list Dropdown
  const getSubjectDropDown = async () => {
    try {
      const data = isInvestigator
        ? { investigator_id: loginId, phase_id: Number(id) }
        : { phase_id: Number(id) };
      const res = await SubAdminApi.getSubAdminDropdown(5, data);
      setsubAdminList(res.data);
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  // Function to get Status  Dropdown
  const getStatusDropDown = async () => {
    try {
      const res = await SubjectApi.subjectStatusDropDown(id);
      setStatusDropdownList(() =>
        res.data.map((item) => {
          return {
            ...item,
            name: `${item.status[0].toUpperCase()}${item.status.slice(1)}`,
          };
        })
      );
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const getDiseaseData = async () => {
    try {
      const decRes = await DiseaseManagementApi.getDiseaseManagementData();
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id"
            ? { ...child,IsRequired: true, data: decRes?.data }
            : child.name == "gender"
            ? { ...child, data: GenderList }
 : child.name == "editor_id"
          ? { ...child, IsRequired: true } // Ensure editor remains required
          : child        ),
      }));
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };
  useEffect(() => {
    getDiseaseData();
    if (!isInvestigator) {
      getStatusDropDown();
    } else {
      getSubjectDropDown();
    }
    getPhaseDetails();
  }, []);

  // Function to get Editor Dropdown
// Function to get Editor Dropdown
const getEditorDropdown = async (Pi_id) => {
  try {
    
    if (Pi_id && Pi_id !== "undefined") {
      let res = await ProductApi.subadminDropDown(
        5,
        Pi_id,
        phaseListDetails?.id
      );
      
      
      // Update the editor dropdown data
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id" ? { 
            ...child, 
            data: res?.data || [],
            placeholder: res?.data?.length > 0 ? "Select Editor" : "No editors available",
             IsRequired: true
          } : child
        ),
      }));

      // If editing an existing subject, preserve the editor_id
      if (!rowId) {
        // For new subjects, reset editor selection when PI changes
        setEditSubjectPatient(prev => ({
          ...prev,
          editor_id: "" // Reset editor when PI changes
        }));
      }
    } else {
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "editor_id"
            ? { 
                ...child, 
                placeholder: "Select Principal Investigator first", 
                data: [] ,
                 IsRequired: true
              }
            : child
        ),
      }));
    }
  } catch (error) {
    dispatch(
      setSnackbar({
        value: true,
        message: error?.message || "Failed to load editors",
        color: "error",
      })
    );
    
    setModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "editor_id"
          ? { 
              ...child, 
              placeholder: "Error loading editors", 
              data: [] ,
               IsRequired: true
            }
          : child
      ),
    }));
  }
};

  const handleDropDownChange = (e, id) => {
    if (id === "selectSubject") {
      setSubAdminID(e.target.value);
      setCurrentpage(1);
    } else if (id === "selectStatus") {
      if (e.target.value) {
        setStatusId(e.target.value);
        setStatus([e.target.value]);
      } else {
        setStatusId(e.target.value);
        setStatus([1, 3]);
      }
      setCurrentpage(1);
    }
  };

  const findFormTypeID = (form_template_id) =>
    phaseListDetails?.form_details?.find(
      (item) => Number(item.type.id) === Number(form_template_id)
    )?.id;

  const handleAddAppointment = async (row) => {
    try {
      const res = await SubAdminApi?.formTemplateOrderwise({
        subject_id: row[row.length - 5],
        phase_id: row[row.length - 4],
      });
      if (res?.data?.length > 0) {
        const dataUpdated =
          res?.data?.map((item) => ({
            id: item?.form_template_id || findFormTypeID(item?.id),
            title: item?.name,
          })) || [];
        setFormTemplateList(dataUpdated);
        setSubjectId(row[row.length - 5]);
        SetIsFormModel(true);
      } else {
 dispatch(
          setSnackbar({
            value: true,
            message: "Required numbers of visits have been recorded",
            color: "error",
          })
        );      }
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const handlePatientCycleConfrim = (confirmation) => {
    setPatientFormValues({});
    if (!confirmation) {
      setPatientCycleConfirm(false);
      setOpenAddSubjectModal(false);
dispatch(
        setSnackbar({
          value: true,
          message: "Duplicate record not created.",
          color: "error",
        })
      );      
      return;
    }
    setPatientCycleLoading(true);
    handleAddSubject(patientFormValues, confirmation);
    setPatientCycleLoading(false);
  };

  const handleSelectFormError = (error) => {
 dispatch(
      setSnackbar({
        value: true,
        message: error,
        color: "error",
      })
    );
    };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc"; // On same column click change order
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  //  @info : Function for change gender value to display into the form
  const getGender = async (isGenderName) => {
    return new Promise((resolve) => {
      switch (isGenderName) {
        case "Male":
          setGender(1);
          resolve(1);
          break;
        case "Female":
          setGender(2);
          resolve(2);
          break;
        case "Others":
          setGender(3);
          resolve(3);
          break;
        default:
          resolve(null); // Handle unexpected input
          break;
      }
    });
  };

  const handleEditSubject = async (row) => {
    setOpenAddSubjectModal(true);
    const rowId = row[row.length - 5];
    setRowId(rowId);
    setDisableDisease(true);

    if (row) {
      setModelData((pre) => ({
        ...pre,
        editTitle: "Edit Patient",
      }));
    }

    const currentPatientData = allSubjectList.find((res) => res.id == rowId);
    const genderValue = await getGender(currentPatientData?.gender);
    getEditorDropdown(currentPatientData?.investigatorDetails?.id, rowId);
    setEditSubjectPatient((prev) => ({
      ...prev,
      first_name: currentPatientData.first_name,
      last_name: currentPatientData?.last_name,
      gender: genderValue, // Use the awaited gender value
      dob: currentPatientData?.dob,
      editor_id: currentPatientData?.editorDetails?.id,
      investigator_id: currentPatientData?.investigatorDetails?.id,
      disease_id: currentPatientData?.disease_id,
      phase_id: phaseListDetails?.id,
      phase_code: phaseListDetails?.phase_code,
      phase_title: phaseListDetails?.title,
      addCycle: currentPatientData?.cycle,
    }));
  };
  // @info : Function to change gender value to string to send into the payload
  const changeGenderPayload = (value) => {
    let genderTransform = "Male";

    switch (value) {
      case 1:
        genderTransform = "Male";
        break;
      case 2:
        genderTransform = "Female";
        break;
      case 3:
        genderTransform = "Others";
        break;
    }

    return genderTransform;
  };

  const handleEditSubjectSubmit = async (values) => {
    try {
      const payload = { ...values };
      payload.gender = changeGenderPayload(values?.gender); // calling function to set gender value
      const response = await SubjectApi.editPatient(payload, rowId);

      // getPhaseDetails(activeTab);/
dispatch(
        setSnackbar({
          value: true,
          message: response.message || "Patient Edited Successfully",
          color: "success",
        })
      );      await getSubjectList();
      setOpenAddSubjectModal(false);
    } catch (error) {
 dispatch(
        setSnackbar({
          value: true,
          message: error.message || error || "Failed to Edit Patient",
          color: "error",
        })
      );    }
  };

  const handleExtra = (row) => {
    const subject = allSubjectList.find((op) => op.id == [row[13]]);
    if (subject?.feasibility_assessments?.qr_code_generations[0]?.id) {
      navigate(
        `/phases/phase-details/${subject?.phase_id}/patient-details/${subject?.id}/inbound-form/${subject?.feasibility_assessments?.qr_code_generations[0]?.id}`
      );
    }
  };

  useEffect(() => {
    if (orderBy) {
      getSubjectList();
    }
  }, [orderBy, order]);

  const handleRecordingDate = async (data) => {
    setRecordedDateLoading(true);
    let updatedValues = {
      title: data.form.title,
      form_template_id: data.form.id || 0,
      phase_id: phaseListDetails.id,
      subject_id: subjectId,
      last_recorded_visit_date: data?.last_recorded_visit_date,
    };

    try {
      // API call to add phase
      const response = await SubjectApi.addAppointment(updatedValues);
      // Dispatch success snackbar message
 dispatch(
        setSnackbar({
          value: true,
          message: response.message || "Appointment added successfully",
          color: "success",
        })
      );      const UpdatedNavigationArray = location.state;
      UpdatedNavigationArray?.push({
        name: "Patient Details",
        path: `${location.pathname}/patient-details/${response?.data?.subject_id}`,
      });
      navigate(`patient-details/${response?.data?.subject_id}`, {
        state: UpdatedNavigationArray,
      });
    } catch (error) {
dispatch(
        setSnackbar({
          value: true,
          message: error?.message || error || "Failed to add appointment",
          color: "error",
        })
      );    } finally {
      setSubjectId("");
      setRecordedDateModel(false);
      setRecordedDateLoading(false); // Reset loading state
    }
  };

  useEffect(() => {
    if (rowId) {
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id" ? { ...child, disabled: true } : child
        ),
      }));
    } else {
      setModelData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "disease_id" ? { ...child, IsRequired: true, disabled: false } : child
        ),
      }));
    }
  }, [rowId]);
  return (
    <div className="p-6">
      <SelectFormModel
        open={isOpenFormModel}
        setOpen={SetIsFormModel}
        isFormLoading={isFormLoading}
        data={formTemplateList}
        SetIsFormLoading={SetIsFormLoading}
        handleValue={hanldeFormSubmit}
        handleError={handleSelectFormError}
      />

      <CustomModel
        modelData={recordedDateModelData}
        open={recordedDateModel}
        setOpen={setRecordedDateModel}
        modalInitialValues={recordedDate}
        initialValuesValidationSchema={recordedDateSchema}
        handleModelValues={handleRecordingDate}
        resistOverFlow={recordedDateModel ?? false} // make it conditional only for date one
        isLoadingBtn={recordedDateLoading}
      />
      {patientCycleConfirm ? (
        <ConfirmationModal
          open={patientCycleConfirm}
          setOpen={setPatientCycleConfirm}
          handleConfirmation={handlePatientCycleConfrim}
          errMessage={patientCycleErrMess}
          isLoading={patientCycleLoading}
        />
      ) : null}
<CustomModel
  rowId={rowId}
  modalInitialValues={rowId ? editSubjectPatient : AddNewSubject}
   initialValuesValidationSchema={
    rowId
      ? editSubjectPhaseValidationSchema
      : isEditor 
        ? addNewSubjectValidationSchema // For editors (no PI/editor fields)
        : addNewSubjectPhaseValidationSchema // For non-editors (with PI/editor fields)
  }
  open={openAddSubjectModal}
  setOpen={setOpenAddSubjectModal}
  modelData={modelData}
  handleModelValues={rowId ? handleEditSubjectSubmit : handleAddSubject}
  isLoadingBtn={isAddSubjectLoading}
  // FIX: Proper onChange handler for PI selection
  onChange={(value, fieldName) => {
    if (fieldName === "investigator_id") {
      getEditorDropdown(value);
    }
  }}
  setRowId={setRowId}
  setDisableDisease={setDisableDisease}
/>
      <div className="mb-3 md:mb-4">
        <BreadCrumb
          BreadCrumbsListing={[
            {
              name: phaseListDetails?.title || 'Phases',
              path: "phases",
            },
            {
              name: "Details",
              path: location.pathname,
            },
          ]}
        />
      </div>
      {phaseListDetails && phaseListDetails.length != 0 ? (
        <div className=" min-h-[25rem] bg-[#FFFFFF]   rounded-xl">
          <CustomWrapperCard
            loading={phaseDetailLoading}
            editDeleteBtn={false}
            disableAddButton={!showAddSubjectButton}
            data={phaseListDetails || {}}
            ShowPI={true}
            ShowEditorCount={isInvestigator}
            ShowProgressBar={false}
            handleAddButtonCard={handleOpenAddSubjectModal}
          />
          <hr className="ml-[1rem] mr-[1rem]   " />

          <TrialInfoComponent
            HeaderTitle={"Description"}
            ShowHeaderButton={false}
          >
            {phaseDetailLoading ? (
              <SkeletonLoader
                rowCount={1}
                isTable={false}
                width={500}
                height={20}
              />
            ) : (
              <Typography variant="p" className="break-words">
                {phaseListDetails?.description?.[0]?.toUpperCase() +
                  phaseListDetails?.description?.slice(1) ||
                  "No Description Added"}
              </Typography>
            )}
          </TrialInfoComponent>
          <hr className="ml-[1rem] mr-[1rem]" />
          <TrialInfoComponent
            HeaderTitle={"Assigned Forms"}
            ShowHeaderButton={false}
          >
            <div className="flex gap-2 justify-start flex-wrap">
              {phaseDetailLoading ? (
                <SkeletonLoader
                  rowCount={2}
                  isTable={false}
                  width={200}
                  height={30}
                />
              ) : (
                <>
                  {phaseListDetails?.template_type_array?.length > 0
                    ? phaseListDetails?.template_type_array?.map((item) => (
                        <CustomDetailComponent
                          key={item?.id || ""}
                          BgColor="#2831720D"
                          FirstHeading={item.name || ""}
                          Icon={<DocumentIcon LightBlue={true} />}
                          ShowDeleteIcon={false}
                        />
                      ))
                    : "No Assigned Forms Found."}
                </>
              )}
            </div>
          </TrialInfoComponent>
          <hr className="ml-[1rem] mr-[1rem]   " />
          {isInvestigator && (
            <>
              <TrialInfoComponent
                HeaderTitle={"Assigned Editor"}
                ShowHeaderButton={false}
              >
                <div className="flex gap-2 justify-start flex-wrap">
                  {phaseDetailLoading ? (
                    <SkeletonLoader
                      rowCount={2}
                      isTable={false}
                      width={200}
                      height={30}
                    />
                  ) : (
                    <>
                      {phaseListDetails?.editor_details?.length > 0
                        ? phaseListDetails?.editor_details?.map((item) => (
                            <CustomDetailComponent
                              key={item?.id || ""}
                              BgColor="#2831720D"
                              FirstHeading={item?.name || ""}
                              Icon={<InvestigatorIcon />}
                              ShowDeleteIcon={false}
                            />
                          ))
                        : "No Assigned Editor Found."}
                    </>
                  )}
                </div>
              </TrialInfoComponent>
              <hr className="ml-[1rem] mr-[1rem]   " />
            </>
          )}

          <div className="p-3">
            <CustomTable
              SearchbarBgColor="secondary"
              alignment={alignment}
              handleExtra={handleExtra}
              setAlignment={setAlignment}
              rows={subjectData?.rows}
              columnAlign={subjectData?.columnAlign}
              columns={subjectData?.columns}
              handleTableFilters={handleTableFilters}
              tableFilters={tableFilters}
              handleChangePage={handlePagination}
              loading={loading}
              currentPage={currentPage}
              totalpage={totalPage}
              TableData={{
                ...subjectData?.TableSearchActions,
                filters: subjectData?.TableSearchActions?.filters?.map(
                  (item) => {
                    if (item?.id === "selectSubject") {
                      return {
                        ...item,
                        MenuList: subAdminList,
                        dropDownValue: subAdminId,
                      };
                    } else if (item?.id === "selectStatus") {
                      return {
                        ...item,
                        MenuList: statusDropdownList,
                        dropDownValue: statusId,
                      };
                    }
                    return item;
                  }
                ),
              }}
              handleAddButton={handleAddAppointment}
              handleEditButton={handleEditSubject}
              handleChangeDropDown={handleDropDownChange}
              handleNavigate={handleNavigateToDetails}
              DropdownBgColor={theme?.palette?.grey[200]}
              order={order}
              orderBy={orderBy}
              EnableSorting={true}
              handleSort={handleSort}
            />
          </div>
        </div>
      ) : (
        <div className="mt-4">
          <NoDataCard />
        </div>
      )}
       <CustomSnackbar
        open={snackbar?.value}
        setOpen={setSnackbar}
        color={snackbar?.color}
        message={snackbar?.message}
      />

    </div>
  );
};
